export const getDate = (label: string) => {
  const dateMatch = label.match(/\((\d{2})\/(\d{2})\/(\d{2})\)/)

  if (!dateMatch) return ''

  const [, day, month, year] = dateMatch

  const currentYear = new Date().getFullYear().toString().slice(0, 2)

  return `${currentYear}${year}-${month}-${day}`
}
